/* ============================================
   SHOP BY BRAND — pagination
   5 blocks per row x 6 rows = 30 blocks per page.
   All blocks are rendered by Liquid; this script
   just shows/hides them in groups and builds the
   page number buttons.
   ============================================ */

(function () {
  function shopbbInit(scriptEl) {
    var sectionId = scriptEl.getAttribute('data-shopbb-section-id');
    var cols = parseInt(scriptEl.getAttribute('data-shopbb-cols'), 10) || 5;
    var rows = parseInt(scriptEl.getAttribute('data-shopbb-rows'), 10) || 6;
    var perPage = cols * rows;

    var container = document.getElementById('new-shopbb-container-' + sectionId);
    var paginationEl = document.getElementById('new-shopbb-pagination-' + sectionId);
    if (!container || !paginationEl) return;

    var items = Array.prototype.slice.call(container.querySelectorAll('.new-shopbb-liquid'));
    var totalPages = Math.max(1, Math.ceil(items.length / perPage));
    var currentPage = 1;

    function renderPage(page) {
      currentPage = Math.min(Math.max(1, page), totalPages);

      items.forEach(function (item, index) {
        var itemPage = Math.floor(index / perPage) + 1;
        item.style.display = itemPage === currentPage ? '' : 'none';
      });

      renderPagination();
      container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function renderPagination() {
      if (totalPages <= 1) {
        paginationEl.innerHTML = '';
        return;
      }

      var html = '';

      html += '<button type="button" class="new-shopbb-page-btn" data-shopbb-page="' + (currentPage - 1) + '"' +
        (currentPage === 1 ? ' disabled' : '') + ' aria-label="Previous page">&laquo;</button>';

      for (var p = 1; p <= totalPages; p++) {
        html += '<button type="button" class="new-shopbb-page-btn' + (p === currentPage ? ' is-active' : '') +
          '" data-shopbb-page="' + p + '">' + p + '</button>';
      }

      html += '<button type="button" class="new-shopbb-page-btn" data-shopbb-page="' + (currentPage + 1) + '"' +
        (currentPage === totalPages ? ' disabled' : '') + ' aria-label="Next page">&raquo;</button>';

      paginationEl.innerHTML = html;
    }

    paginationEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.new-shopbb-page-btn');
      if (!btn || btn.disabled) return;
      renderPage(parseInt(btn.getAttribute('data-shopbb-page'), 10));
    });

    renderPage(1);
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('script[data-shopbb-section-id]').forEach(shopbbInit);
  });

  // Re-init when edited live in the Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var scriptEl = event.target.querySelector('script[data-shopbb-section-id]');
      if (scriptEl) shopbbInit(scriptEl);
    });
  }
})();